import api from './api';

export interface SubscriptionStatus {
    hasSubscription: boolean;
    status: 'free' | 'active' | 'canceled' | 'past_due';
    planName?: string;
    currentPeriodStart?: string;
    currentPeriodEnd?: string;
    cancelAtPeriodEnd?: boolean;
    message?: string;
}

export interface CheckoutSession {
    sessionId: string;
    url: string;
    subscriptionActivated?: boolean;
    message?: string;
    planName?: string;
    currentPeriodEnd?: string;
}

export interface CustomerPortal {
    url: string;
}

/**
 * Create a Stripe checkout session
 */
export const createCheckoutSession = async (
    priceId: string,
    referralCode?: string
): Promise<CheckoutSession> => {
    const response = await api.post('/subscription/create-checkout-session', {
        priceId,
        ...(referralCode ? { referralCode: referralCode.trim().toUpperCase() } : {}),
    });
    return response.data;
};

/**
 * Get current user's subscription status
 */
export const getSubscriptionStatus = async (): Promise<SubscriptionStatus> => {
    const response = await api.get('/subscription/status');
    return response.data;
};

/**
 * Cancel user's subscription
 */
export const cancelSubscription = async (): Promise<any> => {
    const response = await api.post('/subscription/cancel');
    return response.data;
};

/**
 * Get Stripe customer portal URL
 */
export const getCustomerPortal = async (): Promise<CustomerPortal> => {
    const response = await api.post('/subscription/customer-portal');
    return response.data;
};

/**
 * Get subscription plans configuration
 */
export const getSubscriptionPlans = async (): Promise<any> => {
    const response = await api.get('/subscription/plans');
    return response.data;
};
